import React, { useMemo } from 'react';
import SubPage, { PageActions } from '#/common/components/SubPage';
import CapitalNeeds from '../components/CapitalNeeds';
import { useSearchParams } from 'react-router-dom';
import { PageAction } from '#/app/providers/PageProvider';
import useAccessControl from '#/common/hooks/useAccessControl';

const CapitalNeedsPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const assetId = searchParams.get('assetId') || undefined;
  const { canCreateCapitalNeed } = useAccessControl();

  const actions = useMemo<PageAction[]>(() => {
    const newPath = assetId ? `/capital-needs/new?assetId=${assetId}` : '/capital-needs/new';
    if (!canCreateCapitalNeed) return [];
    return [
      {
        id: 'new-capital-need',
        alwaysShow: true,
        type: 'button',
        props: {
          type: 'submit',
          icon: 'add',
          label: 'Create New Capital Need',
          responsive: true,
          path: newPath,
        },
      },
    ];
  }, [assetId, canCreateCapitalNeed]);

  return (
    <SubPage title="Capital Needs" type="list">
      <PageActions actions={actions} />
      <CapitalNeeds hideNewAction />
    </SubPage>
  );
};

export default CapitalNeedsPage;
